const fontVariables = [
  {
    fontFamily: "Poppins",
    fontUrl: "/fonts/Poppins/Poppins-Regular.ttf",
    fontFormat: "truetype",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    fontFamily: "Poppins",
    fontUrl: "/fonts/Poppins/Poppins-Medium.ttf",
    fontFormat: "truetype",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    fontFamily: "Poppins",
    fontUrl: "/fonts/Poppins/Poppins-SemiBold.ttf",
    fontFormat: "truetype",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    fontFamily: "Poppins",
    fontUrl: "/fonts/Poppins/Poppins-Bold.ttf",
    fontFormat: "truetype",
    fontWeight: 700,
    fontStyle: "normal",
  },
];

export default fontVariables;
